// extracted by mini-css-extract-plugin
export default {"modal":"Rha-z","header":"Sha-z","fields":"Tha-z","error":"Uha-z","disabled":"Vha-z","reminderMsg":"Wha-z","errorMsg":"Xha-z","footer":"Yha-z"};